import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDubbelglasKozijn = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#C2F1FC"
      d="M29 8.25V5L9 10v22l3-.9V12.5z"
    />
    <path
      fill="#C2F1FC"
      d="M29 8.25v17.73L12 31.1V33l20-6.02V7.5z"
    />
    <path
      fill="#85E3F9"
      d="M29 8.25 12 12.5v18.6l17-5.12z"
    />
    <path
      fill="#00C5F2"
      d="m34 31-20 6v-3.5l20-6z"
    />
    <path
      fill="#00C5F2"
      d="m32 25-20 6 2 2.5 20-6zM8 32l4-1v2z"
    />
    <path
      fill="#223357"
      fillRule="evenodd"
      d="m16.858 7.535.244.97L9 10.54v22.01H8V9.76z"
      clipRule="evenodd"
    />
    <path
      fill="#223357"
      fillRule="evenodd"
      d="m23.879 9.015.242.97L12 13.02V33h-1V12.24z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M8 30v2l4 1v-2l2 2.5V37l-8-2v-3.27z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDubbelglasKozijn);

export default ForwardRef;
